import React from 'react'
import dayjs from 'dayjs'
import $msg from './message'
export const INPUT_NUMBER_LIMIT_REGEXP = /^\d{0,4}(\.\d{0,2})?$/
export const INPUT_PRICE_LIMIT_REGEXP = /^\d{0,6}(\.\d{0,2})?$/
export const isArray = require('lodash/isArray')
export const get = require('lodash/get')
export const setObj = require('lodash/set')
export const uniqBy = require('lodash/uniqBy')

export const WithInputLimit = function (WrappedComponent: any, reg: RegExp, maxNum?: number, minNum?: number) {
    const props = WrappedComponent.props

    return React.createElement('input', {
        ...props,
        onChange: function (e: any) {
            let value: string = e.currentTarget.value
            do {
                if (!reg.test(value)) {
                    if (value.length > 0) {
                        value = value.substr(0, value.length - 1)
                        e.currentTarget.value = value
                        continue
                    } else {
                        break
                    }
                }
                if (maxNum && parseFloat(value) > maxNum) {
                    e.currentTarget.value = maxNum
                    continue
                }
                if (minNum && parseFloat(value) < minNum) {
                    e.currentTarget.value = minNum
                    continue
                }
            } while (!reg.test(value))
            props.onChange(e)
        },
    })
}

export function transfromNumberToHanzi(type: number) {
    switch (type) {
        case 1:
            return '一'
        case 2:
            return '二'
        case 3:
            return '三'
        case 4:
            return '四'
        case 5:
            return '五'
        case 6:
            return '六'
        case 7:
            return '七'
        case 8:
            return '八'
        case 9:
            return '九'
        case 10:
            return '十'
    }
}

// 根据KB 大小进行计算
export function getFilesSizeMax(val: number) {
    if (val < 1024) {
        return val + 'KB'
    } else {
        return (val / 1024).toFixed(1) + 'M'
    }
}

// 获取视频时间
export function getVideoTimes(times: number | any) {
    if (times === null || times === '') {
        return '--:--:--'
    } else if (times <= 60) {
        return `00:${times >= 10 ? times : '0' + times}`
    } else if (times > 60 && times <= 3600) {
        return (
            +(Math.floor(times / 60) >= 10 ? Math.floor(times / 60) : '0' + Math.floor(times / 60)) +
            ':' +
            (times % 60 >= 10 ? times % 60 : '0' + (times % 60))
        )
    } else if (times > 3600) {
        // return Math.floor(times / 3600) + Math.floor(times / 3600)
        return '--:--:--'
    } else {
        return '--:--:--'
    }
}

export function formatTime(time: string) {
    const timeArr = time.split(' ')
    const isToday = dayjs(timeArr[0]).format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD')
    const sameYear = dayjs(timeArr[0]).format('YY') === dayjs().format('YY')

    return isToday ? timeArr[1] : sameYear ? [timeArr[0].slice(5, 10), timeArr[1]] : time
}

type diffIndex = '0' | '-1' | '-2' | '1' | '2'
/**
 * 将YYYY-MM-DD格式时间转为昨天、前天等语义化时间
 * @param time YYYY-MM-DD 格式时间
 */
export function formatDay(time?: string) {
    if (!time) return ''

    const diffMap = {
        '0': '今天',
        '1': '昨天',
        '2': '前天',
        '-1': '明天',
        '-2': '后天',
    }

    const diff = dayjs(dayjs().format('YYYY-MM-DD')).diff(time, 'd')
    const r = diffMap[`${diff}` as diffIndex]
    const sameYear = dayjs(time).format('YY') === dayjs().format('YY')

    return r ? r : sameYear ? dayjs(time).format('MM-DD') : time
}

export const formatPrice = (price: number | undefined) => `${(price || 0) >= 0 ? '' : '-'}¥${Math.abs(price || 0)}`

export const deepClone = (val: any) => JSON.parse(JSON.stringify(val))

/**
 * 获取图片的 base64 编码 DataURL
 * @param image JS 图像对象
 * @return {string} 已编码的 DataURL
 */
function getImageDataURL(image: HTMLImageElement) {
    // 创建画布
    const canvas: HTMLCanvasElement = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const ctx = canvas.getContext('2d')
    // 以图片为背景剪裁画布
    ctx?.drawImage(image, 0, 0, image.width, image.height)
    // 获取图片后缀名
    const extension = image.src.substring(image.src.lastIndexOf('.') + 1).toLowerCase()

    // 某些图片 url 可能没有后缀名，默认是 png
    return canvas.toDataURL('image/' + extension, 1)
}

export const downloadImg = (url: string, downloadName: string) => {
    const tag = document.createElement('a')
    // 此属性的值就是**时图片的名称，注意，名称中不能有半角点，否则**时后缀名会错误
    tag.setAttribute('download', downloadName)

    const image = new Image()
    // 设置 image 的 url, 添加时间戳，防止浏览器缓存图片
    image.src = url + '?time=' + new Date().getTime()
    // 重要，设置 crossOrigin 属性，否则图片跨域会报错
    image.setAttribute('crossOrigin', 'Anonymous')
    // 图片未加载完成时操作会报错
    image.onload = () => {
        tag.href = getImageDataURL(image)
        tag.click()
    }
}

export const download = (url: string | Blob, saveName: string, prefix: string = '.xlsx') => {
    if (typeof url === 'string' && url.startsWith('http:')) {
        url = url.replace('http', 'https')
    }
    console.info(url)
    if (typeof url == 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url) // 创建blob地址
    }
    const aLink = document.createElement('a')
    aLink.href = url
    aLink.download = saveName + prefix || '表格.xlsx'
    let event
    if (window.MouseEvent) {
        event = new MouseEvent('click')
    } else {
        event = document.createEvent('MouseEvents')
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    }
    aLink.dispatchEvent(event)
}

export const errorCallBack = (e: any) => $msg('error', e.message)

export const isExist = (q: any) => {
    if (q instanceof Object) {
        if (String(q)) {
            return !!Object.keys(q).length
        } else {
            return !!String(q)
        }
    }

    return !!q
}

export const tranfromLoadErrorImg = () => {
    document.addEventListener(
        'error',
        e => {
            let target: HTMLElement | null = e.target as HTMLElement
            const tagName = target?.tagName || ''
            const curTimes = Number(target?.dataset.retryTimes) || 0
            if (tagName.toLowerCase() === 'img') {
                if (curTimes > 3) return

                const imageTarget = target as HTMLImageElement
                imageTarget.src = 'https://img.senguo.cc/FkvY8zkeCTU97-uwebfxO4m9IQgi'
                imageTarget.dataset.retryTimes = `${curTimes + 1}`
            }
            target = null
        },
        true,
    )
}

export const formCreateTimeShow = (time: string, n: number) => {
    const createTime = dayjs(time)
    const futureTime = createTime.add(n, 'day')
    const hoursDiff = futureTime.diff(dayjs(), 'hour')
    const days = Math.floor(hoursDiff / 24)
    const remainingHours = hoursDiff % 24

    return `${days}天${remainingHours}小时`
}
